<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
	  <ProductionOutMenu></ProductionOutMenu>
        <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Statusy</h4>
              <button v-if="hasPermission('canAddproductionOutStatus')" @click="addStatus"
                      class="btn btn-primary btn-sm">
                <i class="bi bi-plus-circle me-2"></i>Dodaj status
              </button>
            </div>
          </div>
        </div>
        <div class="widget-content">
          <div class="custom-table">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th>#</th>
                  <th>Nazwa statusu</th>
                  <th>Zaktualizowany</th>
                  <th>Akcje</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(status, index) in statusy" :key="index">
                  <td>{{ status.id }}</td>
                  <td>
                    <input v-if="editingId === status.id" v-model="status.name" class="form-control"/>
                    <span v-else>{{ status.name }}</span>
                  </td>
                  <td>{{ formatDate(status.updated_at) }}</td>
                  <td>
                    <button v-if="editingId === status.id" @click="updateStatus(status)"
                            class="btn btn-sm btn-success me-2">Zapisz
                    </button>
                    <button v-else-if="hasPermission('canAddproductionOutStatus')" @click="editStatus(status.id)"
                            class="btn btn-sm btn-outline-info me-2"><i class="bi bi-pencil me-2"></i>Edytuj
                    </button>
                    <button v-if="hasPermission('canDelproductionOutStatus')" @click="deleteStatus(status.id)"
                            class="btn btn-sm btn-danger"><i class="bi bi-trash me-2"></i>Usuń
                    </button>
                  </td>
                </tr>
                <tr v-if="addingNew">
                  <td>Nowy</td>
                  <td><input v-model="newStatus.name" class="form-control"/></td>
                  <td>-</td>
                  <td>-</td>
                  <td>
                    <button @click="saveNewStatus" class="btn btn-sm btn-success me-1"><i class="bi bi-save me-2"></i>Zapisz
                    </button>
                    <button @click="cancelNewStatus" class="btn btn-sm btn-danger"><i class="bi bi-x-circle me-2"></i>Anuluj
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";
import ProductionOutMenu from "@/Pages/ProductionOut/parts/ProductionOutMenu.vue";

const {hasPermission} = usePermission();

export default {
  components: {AppLayout, ProductionOutMenu},
  props: {
    statusy: Array
  },
  data() {
    return {
      hasPermission,
      editingId: null,
      addingNew: false,
      newStatus: this.getEmptyForm()
    };
  },
  methods: {
    formatDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      return date.toISOString().split('T')[0];
    },
    getEmptyForm() {
      return {
        id: null,
        name: ''
      };
    },
    addStatus() {
      this.addingNew = true;
      this.newStatus = this.getEmptyForm();
    },
    cancelNewStatus() {
      this.addingNew = false;
      this.newStatus = this.getEmptyForm();
    },
    editStatus(id) {
      this.editingId = id;
    },

    updateStatus(status) {
      this.$inertia.put(route('production.out.statusy.update', status.id), status, {
        onSuccess: () => {
          this.editingId = null;
        }
      });
    },
    saveNewStatus() {
      this.$inertia.post(route('production.out.statusy.store'), this.newStatus, {
        onSuccess: () => {
          this.addingNew = false;
          this.newStatus = this.getEmptyForm();
        }
      });
    },
    deleteStatus(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie statusu',
        html: 'Czy na pewno chcesz usunąć wybrany status?',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
        timer: false,
        position: 'center'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(route('production.out.statusy.destroy', id));
        }
      });
    }
  }
};
</script>

<style scoped>

</style>
